<template>
  <section class="user-subscription">
    <div
      v-if="hasSubscription"
      class="user-subscription__content"
    >
      <div class="user-subscription__item">
        <span>
          {{ $t('userAccount.subscription-mode') }}
        </span>
        <span class="user-subscription__item-value">
          {{ userInfoStore.subscription.productName }}
        </span>
      </div>
      <div class="user-subscription__item">
        <span>
          {{ $t('userAccount.subscription-status') }}
        </span>
        <span
          :class="[
            'user-subscription__item-value',
            'user-subscription__item-active'
          ]"
        >
          {{ $t('userAccount.subscription-status.active') }}
        </span>
      </div>
      <div class="user-subscription__item">
        <span>
          {{ $t('userAccount.next-payment') }}
        </span>
        <span
          class="user-subscription__item-value"
          v-html="nextBillingText"
        />
      </div>
      <div class="user-subscription__item">
        <span>
          {{ $t('userAccount.payment-method') }}
        </span>
        <span class="user-subscription__item-value">
          {{ userInfoStore.subscription.paymentMethod }}
        </span>
      </div>
      <div class="user-subscription__actions">
        <div
          v-if="showUnsubscribeButton"
          class="user-subscription__link"
          @click="cancelSubscriptionClick(openUnsubscribeModal)"
        >
          {{ $t('userAccount.cancel-subscription') }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="user-subscription__content"
    >
      <div class="user-subscription__unsubscribed">
        {{ $t('userAccount.subscription-empty') }}
      </div>
    </div>
  </section>
</template>

<script>
import { DateTime } from 'luxon';
import CancelSubscriptionAction from '@/mixins/CancelSubscriptionAction/CancelSubscriptionAction';

export default {
    mixins: [CancelSubscriptionAction()],
    props: {
        showUnsubscribeButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasSubscription () {
            return this.userInfoStore.subscription.subscriptionType === 'pro';
        },
        nextBillingText () {
            const {dueDate, isSubscribed} = this.userInfoStore.subscription;
            const formattedDate = DateTime.fromISO(dueDate).toLocaleString();

            if (isSubscribed && dueDate && this.userInfoStore.subscription.typeLicense === 'subscription') {
                return formattedDate;
            }
            if ((!isSubscribed && dueDate) || (this.userInfoStore.subscription.typeLicense === 'oneTimePayment' && dueDate)) {
                return this.$t('userAccount.subscription-date.cancelled', {date: formattedDate});
            }
            return this.$t('userAccount.subscription-date.never');
        },
    },
    methods: {
        openUnsubscribeModal() {
            this.$emit('open-unsubscribe-modal');
        },
    },
};
</script>

<style src="./UserSubscriptionComponent.scss" lang="scss" />
